import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userExpenseNotificationMessages = {
  [AutomationEventTypes.ExpenseCreated]: {
    subject: 'Expense Created - *|GUEST:NAME|*',
    message: `
      Hi Team,

      An expense has been created for the guest’s booking at *|RENTAL:NAME|*. Please review and update records accordingly.

      Expense Details:
      Guest Name: *|GUEST:NAME|*
      Amount: *|EXPENSE:AMOUNT|*
      Description: *|EXPENSE:DESCRIPTION|*
      Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
    `,
  },
  [AutomationEventTypes.ExpenseApproved]: {
    subject: 'Expense Approved – *|GUEST:NAME|*',
    message: `
      Hi Team,

      The expense for the booking has been approved. Please proceed with any necessary follow-up actions.

      Expense Details:
      Guest Name: *|GUEST:NAME|*
      Expense Amount: *|EXPENSE:AMOUNT|*
      Description: *|EXPENSE:DESCRIPTION|*
      Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
      `,
  },
  [AutomationEventTypes.ExpenseDenied]: {
    subject: 'Expense Denied – *|GUEST:NAME|*',
    message: `
      Hi Team,

      The expense for the booking has been denied. Please review and take appropriate actions if needed.

      Expense Details:
      Guest Name: *|GUEST:NAME|*
      Expense Amount: *|EXPENSE:AMOUNT|*
      Description: *|EXPENSE:DESCRIPTION|*
      Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
      `,
  },
  [AutomationEventTypes.ExpenseDeleted]: {
    subject: 'Expense Deleted – *|GUEST:NAME|*',
    message: `
      Hi Team,

      The expense for the booking has been deleted. Please review and take appropriate actions if needed.

      Expense Details:
      Guest Name: *|GUEST:NAME|*
      Expense Amount: *|EXPENSE:AMOUNT|*
      Description: *|EXPENSE:DESCRIPTION|*
      Check-in/Check-out: *|INQUIRY:ARRIVE|* to *|INQUIRY:DEPART|*
      `,
  },
}

export const guestExpenseNotificationMessages = {
  [AutomationEventTypes.ExpenseCreated]: {
    subject: 'Expense Created for Your Stay at *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      We wanted to inform you that an expense has been created for your booking at *|RENTAL:NAME|*.

      Expense Details:
      Amount: *|EXPENSE:AMOUNT|*
      Description: *|EXPENSE:DESCRIPTION|*

      If you have any questions or need further clarification, please feel free to contact us at *|RENTAL:PHONE|*.
    `,
  },
}
